import { render, staticRenderFns } from "./MsgManual.vue?vue&type=template&id=c87cb8f4&scoped=true"
import script from "./MsgManual.vue?vue&type=script&lang=js"
export * from "./MsgManual.vue?vue&type=script&lang=js"
import style0 from "./MsgManual.vue?vue&type=style&index=0&id=c87cb8f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cb8f4",
  null
  
)

export default component.exports